import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/746b1d40/node_modules/gatsby-theme-carbon/src/templates/Default.js";
import { CheckmarkFilled16 } from "@carbon/icons-react";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ComponentDemo = makeShortcode("ComponentDemo");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">



    <h2>{`Structured list`}</h2>
    <ComponentDemo links={{
      React: "https://react.carbondesignsystem.com/?path=/story/structuredlist--simple",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-structured-list--basic",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvstructuredlist--default",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=structured-list"
    }} mdxType="ComponentDemo">
  {`
<StructuredListWrapper ariaLabel="Structured list">
  <StructuredListHead>
    <StructuredListRow
      head
      tabIndex={0}
    >
      <StructuredListCell head>
        ColumnA
      </StructuredListCell>
      <StructuredListCell head>
        ColumnB
      </StructuredListCell>
      <StructuredListCell head>
        ColumnC
      </StructuredListCell>
    </StructuredListRow>
  </StructuredListHead>
  <StructuredListBody>
    <StructuredListRow tabIndex={0}>
      <StructuredListCell>
        Row 1
      </StructuredListCell>
      <StructuredListCell>
        Row 1
      </StructuredListCell>
      <StructuredListCell>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc dui magna, finibus id tortor sed, aliquet bibendum augue. Aenean posuere sem vel euismod dignissim. Nulla ut cursus dolor. Pellentesque vulputate nisl a porttitor interdum.
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow tabIndex={0}>
      <StructuredListCell>
        Row 2
      </StructuredListCell>
      <StructuredListCell>
        Row 2
      </StructuredListCell>
      <StructuredListCell>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc dui magna, finibus id tortor sed, aliquet bibendum augue. Aenean posuere sem vel euismod dignissim. Nulla ut cursus dolor. Pellentesque vulputate nisl a porttitor interdum.
      </StructuredListCell>
    </StructuredListRow>
  </StructuredListBody>
</StructuredListWrapper>
  `}
    </ComponentDemo>
    <h2>{`Structured list with selection`}</h2>
    <ComponentDemo scope={{
      CheckmarkFilled16
    }} links={{
      React: "https://react.carbondesignsystem.com/?path=/story/structuredlist--selection",
      Angular: "https://angular.carbondesignsystem.com/?path=/story/components-structured-list--with-selection",
      Vue: "http://vue.carbondesignsystem.com/?path=/story/components-cvstructuredlist--selectable-with-vmodel",
      Vanilla: "https://the-carbon-components.netlify.com/?nav=structured-list"
    }} knobs={{
      StructuredListWrapper: ["border"],
      StructuredListRow: ["label"],
      StructuredListCell: ["noWrap"]
    }} mdxType="ComponentDemo">
  {`
<StructuredListWrapper selection ariaLabel="Structured list">
  <StructuredListHead>
    <StructuredListRow
      head
      tabIndex={0}
    >
      <StructuredListCell head>
        ColumnA
      </StructuredListCell>
      <StructuredListCell head>
        ColumnB
      </StructuredListCell>
      <StructuredListCell head>
        ColumnC
      </StructuredListCell>
      <StructuredListCell head/>
    </StructuredListRow>
  </StructuredListHead>
  <StructuredListBody>
    <StructuredListRow tabIndex={0}>
      <StructuredListCell>
        Row 1
      </StructuredListCell>
      <StructuredListCell>
        Row 1
      </StructuredListCell>
      <StructuredListCell>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc dui magna, finibus id tortor sed, aliquet bibendum augue. Aenean posuere sem vel euismod dignissim. Nulla ut cursus dolor. Pellentesque vulputate nisl a porttitor interdum.
      </StructuredListCell>
      <StructuredListInput
        id="row-1"
        value="row-1"
        title="row-1"
        name="row-1"
        defaultChecked
      />
     <StructuredListCell>
        <CheckmarkFilled16
          className="bx--structured-list-svg"
          aria-label="select an option">
          <title>select an option</title>
        </CheckmarkFilled16>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow tabIndex={0}>
      <StructuredListCell>
        Row 2
      </StructuredListCell>
      <StructuredListCell>
        Row 2
      </StructuredListCell>
      <StructuredListCell>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc dui magna, finibus id tortor sed, aliquet bibendum augue. Aenean posuere sem vel euismod dignissim. Nulla ut cursus dolor. Pellentesque vulputate nisl a porttitor interdum.
      </StructuredListCell>
      <StructuredListInput
        id="row-2"
        value="row-2"
        title="row-2"
        name="row-2"
      />
     <StructuredListCell>
        <CheckmarkFilled16
          className="bx--structured-list-svg"
          aria-label="select an option">
          <title>select an option</title>
        </CheckmarkFilled16>
      </StructuredListCell>
    </StructuredListRow>
    <StructuredListRow tabIndex={0}>
      <StructuredListCell>
        Row 3
      </StructuredListCell>
      <StructuredListCell>
        Row 3
      </StructuredListCell>
      <StructuredListCell>
        Lorem ipsum dolor sit amet, consectetur adipiscing elit. Nunc dui magna, finibus id tortor sed, aliquet bibendum augue. Aenean posuere sem vel euismod dignissim. Nulla ut cursus dolor. Pellentesque vulputate nisl a porttitor interdum.
      </StructuredListCell>
      <StructuredListInput
        id="row-3"
        value="row-3"
        title="row-3"
        name="row-3"
      />
     <StructuredListCell>
        <CheckmarkFilled16
          className="bx--structured-list-svg"
          aria-label="select an option">
          <title>select an option</title>
        </CheckmarkFilled16>
      </StructuredListCell>
    </StructuredListRow>
  </StructuredListBody>
</StructuredListWrapper>
  `}
    </ComponentDemo>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      